import httpService from './httpService'
import SessionService from './sessionService'

async function addCommission(data) {
  return httpService.apiRequest(
    'post',
    `/settings/${SessionService.getUserUsername()}/settings/agentCommission`,
    data,
  )
}

async function getCommission() {
  return httpService.apiRequest(
    'get',
    `/settings/${SessionService.getUserUsername()}/settings/agentCommission`,
  )
}

export default {
  addCommission,
  getCommission,
}
